import { useEffect } from 'react';
import { initPendo } from '@locus-taxy/encore-observability/pendo';
import { createPendoData } from '../utils/pendoUtil';
import { useUserId } from './useUser';

export const useAnalytics = ({ clientId }: { clientId: string }) => {
  const userId = useUserId();

  useEffect(() => {
    if (!clientId || !userId) return;

    const { visitorData, accountData } = createPendoData({
      clientId,
      personnelId: userId,
    });
    const apiKey = import.meta.env.VITE_PENDO_API_KEY;

    initPendo({ apiKey, visitor: visitorData, account: accountData });
  }, [clientId, userId]);
};
